module.exports = __webpack_public_path__ + "img/vcf_icm.f7e9ab2a.jpg";